module.exports = __webpack_public_path__ + "img/mehmet-bey@2x.617ebf77.png";